/** Canvas-space helpers for DOM-direct drag (commit to store on mouseup only). */

export function getPanningLayer(): HTMLElement | null {
  return document.querySelector('[data-panning-layer="true"]') as HTMLElement | null;
}

export function clientToCanvas(
  clientX: number,
  clientY: number,
  layerRect: DOMRect,
  zoom = 1
): { x: number; y: number } {
  const z = zoom || 1;
  return {
    x: (clientX - layerRect.left) / z,
    y: (clientY - layerRect.top) / z,
  };
}

export function readElementCanvasPos(el: HTMLElement | null): { x: number; y: number } | null {
  if (!el) return null;
  const left = parseFloat(el.style.left);
  const top = parseFloat(el.style.top);
  if (!Number.isFinite(left) || !Number.isFinite(top)) return null;
  return { x: left, y: top };
}

export function applyElementCanvasPos(el: HTMLElement | null, x: number, y: number): void {
  if (!el) return;
  el.style.left = `${x}px`;
  el.style.top = `${y}px`;
}

export type CanvasPoint = { x: number; y: number };
type EquipmentDragListener = (equipmentId: string, position: CanvasPoint | null) => void;
const equipmentDragListeners = new Set<EquipmentDragListener>();

/** Live icon position during drag — no Zustand, no React. */
export function subscribeEquipmentDrag(listener: EquipmentDragListener): () => void {
  equipmentDragListeners.add(listener);
  return () => {
    equipmentDragListeners.delete(listener);
  };
}

export function notifyEquipmentDrag(equipmentId: string, position: CanvasPoint | null): void {
  equipmentDragListeners.forEach((fn) => fn(equipmentId, position));
}
